import Backdrop from "@mui/material/Backdrop";
import { LoadingScene } from "./loading-scene";

interface LoadingSceneBackdropProps {
	logoUrl?: string;
}

export const LoadingSceneBackdrop = ({
	logoUrl,
}: LoadingSceneBackdropProps) => {
	return (
		<Backdrop
			open
			invisible
			data-testid="LoadingBackdrop">
			<LoadingScene logoUrl={logoUrl} />
		</Backdrop>
	);
};
